import { render, staticRenderFns } from "./CloudBackupIcon.vue?vue&type=template&id=0ed2fcd2&scoped=true&"
import script from "./CloudBackupIcon.vue?vue&type=script&lang=js&"
export * from "./CloudBackupIcon.vue?vue&type=script&lang=js&"
import style0 from "./CloudBackupIcon.vue?vue&type=style&index=0&id=0ed2fcd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed2fcd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ed2fcd2')) {
      api.createRecord('0ed2fcd2', component.options)
    } else {
      api.reload('0ed2fcd2', component.options)
    }
    module.hot.accept("./CloudBackupIcon.vue?vue&type=template&id=0ed2fcd2&scoped=true&", function () {
      api.rerender('0ed2fcd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/CloudBackupIcon.vue"
export default component.exports